import {TestType} from '@esgi/main/libs/core';
import {CardHeaderBox, testTypeLabelCss} from './index.styled';
import {OneLinedText, TestColorIndicator} from '@esgi/main/kits/common';
import {TestTypeLabel} from '../../../../../../../../kit';

type Props = {
	testID: number;
	testName: string;
	testType: TestType;
};

export function CardHeader({testID, testName, testType}: Props) {
	return (
		<CardHeaderBox>
			<TestColorIndicator testID={testID} />

			<OneLinedText
				size='xLarge'
				color='neutral20'
				css={{
					lineHeight: '21px',
				}}
			>
				{testName}
			</OneLinedText>

			<TestTypeLabel testType={testType} css={testTypeLabelCss} />
		</CardHeaderBox>
	);
}
